<app-ds-autocomplete
	[label]="label"
	[placeholder]="placeholder"
	[hint]="currentHint"
	[required]="required"
	[disabled]="isDisabled"
	[options]="tiposProyecto"
	[displayWith]="displayTipoProyecto"
	[value]="selectedTipoProyecto"
	(valueChange)="onValueChange($event)"
	(touched)="onControlTouched()"
></app-ds-autocomplete>
